import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import LineChart from "../charts/LineChart";
import employedSwitzerland from "../../data/employedSwitzerland";
import trendEmployeesSwitzerland from "../../data/trendEmployeesSwitzerland";
import trendNeedEmployees from "../../data/trendNeedEmployees";
import trendAvailabilityEmployees from "../../data/trendAvailabilityEmployees";
import cumulativeDemographic from "../../data/cumulativeDemographic";
import netImmigrationCh from "../../data/netImmigrationCh";
import netImmigrationPT from "../../data/netImmigrationPT";
import netImmigrationDE from "../../data/netImmigrationDE";
import netImmigrationFR from "../../data/netImmigrationFR";
import netImmigrationIT from "../../data/netImmigrationIT";
import BarChart from "../charts/BarChart";


const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;
const Image = styled.img(props => [
    props.imageRounded && tw`rounded`,
    props.imageBorder && tw`border`,
    props.imageShadow && tw`shadow`,
]);

const netImmigrationChData = {
    label: "Switzerland",
    data: netImmigrationCh,
    backgroundColor: 'rgb(3, 194, 252)'
}

const netImmigrationPTData = {
    label: "Portugal",
    data: netImmigrationPT,
    backgroundColor: 'rgb(3, 107, 252)'
}

const netImmigrationDEData = {
    label: "Germany",
    data: netImmigrationDE,
    backgroundColor: 'rgb(67, 191, 104)'
}

const netImmigrationFRData = {
    label: "France",
    data: netImmigrationFR,
    backgroundColor: 'rgb(163, 212, 178)'
}

const netImmigrationITData = {
    label: "Italy",
    data: netImmigrationIT,
    backgroundColor: 'rgb(214, 217, 41)'
}


export default ({
                    title = "",
                    d1 = "",
                    d21 = "",
                    d22 = "",
                    d23 = "",
                    d24 = "",
                    d25 = "",
                    d26 = "",
                    d27 = "",
                    d3 = "",
                    d4 = "",
                    d5 = "",
                    d6 = "",
                    d7 = "",
                    image1="",
                    subtitle1="",
                    subtitle2="",
                }) => {
    return (
        <>
            <h1>{title}</h1>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <BarChart
                        data={[netImmigrationChData, netImmigrationPTData, netImmigrationDEData, netImmigrationFRData, netImmigrationITData]}
                        title="Net immigration to Switzeland"
                    />
                    <p>
                        {image1}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d1}
            </p>
            <p>
                {d21}<br/>
                {d22}<br/>
                {d23}<br/>
                {d24}<br/>
                {d25}<br/>
                {d26}<br/>
                {d27}<br/>
            </p>
            <p>
                {d3}
            </p>
            <strong>{subtitle1}</strong>
            <p>
                {d4}
            </p>
            <strong>{subtitle2}</strong>
            <p>
                {d5}
            </p>
            <p>
                {d6}
            </p>
            <p>
                {d7}
            </p>

        </>
    );
};
